'use strict';

var getExtendedDate = require('./getExtendedDate');

function createDate(d, options, forceClone) {
  return getExtendedDate(null, d, options, forceClone).date;
}

module.exports = createDate;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/createDate.js
// module id = 29
// module chunks = 0